import { render, staticRenderFns } from "./SystemEMail.vue?vue&type=template&id=52803357&"
import script from "./SystemEMail.vue?vue&type=script&lang=js&"
export * from "./SystemEMail.vue?vue&type=script&lang=js&"
import style0 from "./SystemEMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports